const resultsSteps= [
    {
      content: <h2>Let's begin !</h2>,
      locale: { skip: <strong>SKIP</strong> },
      placement: "center",
      target: "body"
    },
    {
      content: <h2>In this section, you can view the graph showing the percentage of user responses to the survey questions.</h2>,
      placement: "bottom",
      target: "#resultsQuestionData",
      title: "First step"
    },
    {
      content: <h2>In this section, you can navigate between questions using the previous and next buttons. There is also an area that allows you to refresh the graph data instantly.</h2>,
      placement: "bottom",
      target: "#resultsButtons",
      title: "Second step"
    },
    {
      content: <h2>In this section, you can filter by user to view the response given by that user for the selected question.</h2>,
      placement: "bottom",
      target: "#resultsUserFilter",
      title: "Third step"
    },
    {
      content: <h2>In this area, you can see the hierarchical structure of sections, pages, and questions. Here, you can select any section, page, or question to navigate through the results page.</h2>,
      placement: "left",
      target: "#resultsLeftMenuNavigate",
      title: "Fourth step"
    },
  ]
  export default resultsSteps;